import React from 'react';
import {
  Link
} from "react-router-dom";
import { Button, Menu, MenuItem, } from '@material-ui/core/';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DataEntry from './DataEntry';
import Administration from './Administration';
import Outputs from './Outputs';
let list = [];

export default function (props) {

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  if (props.value === 'de') list = DataEntry;
  if (props.value === 'op') list = Outputs;
  if (props.value === 'ar') list = Administration;
  const access_rights = JSON.parse(localStorage.getItem('access_right'))

  return (
    <div>
      <Button color="inherit" className="menu-btn" onClick={handleClick}>
        {props.title}
        <ArrowDropDownIcon />
      </Button>
      <Menu id={props.value}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {
          list.map((h, index) => {
            return (
              !(h.link === "/year_overview_customers" && Number(access_rights.year_overview_customers) === 0) &&
              !(h.link === "/resource_planning" && Number(access_rights.year_overview_resource_planning) === 0) &&
              !(h.link === "/vacation_overview" && Number(access_rights.year_overview_vacation) === 0) &&
              !(h.link === "/year_overview_consultants" && Number(access_rights.year_overview_consultants) === 0) &&
              !(h.link === "/year_overview_students" && Number(access_rights.year_overview_students) === 0) &&
              !(h.link === "/year_overview_themes" && Number(access_rights.year_overview_themes) === 0) &&
              !(h.link === "/year_overview_leads" && Number(access_rights.year_overview_leads) === 0) &&
              !(h.link === "/list_of_leads" && Number(access_rights.leads) === 0) &&
              !(h.link === "/year_overview_projects" && Number(access_rights.year_overview_projects) === 0) &&
              !(h.link === "/archive" && Number(access_rights.archive) === 0) &&
              !(h.link === "/6_month_plan" && Number(access_rights.months_plan) === 0) &&
              !(h.link === "/consultant_plan" && (Number(access_rights.consultant_plan) === 0 && Number(access_rights.consultant_plan_for_own) === 0)) &&
              !(h.link === "/users" && Number(access_rights.users) === 0) &&
              !(h.link === "/user_categories" && Number(access_rights.user_categories) === 0) &&
              !(h.link === "/consultant_functions" && Number(access_rights.consultant_functions) === 0) &&
              !(h.link === "/classifications" && Number(access_rights.classifications) === 0) &&
              !(h.link === "/branches" && Number(access_rights.branches) === 0) &&
              !(h.link === "/themes" && Number(access_rights.themes) === 0) &&
              !(h.link === "/countries" && Number(access_rights.countries) === 0) &&
              !(h.link === "/public_holidays" && Number(access_rights.public_holidays) === 0) &&
              !(h.link === "/projects" && (Number(access_rights.projects_basedata_for_other) === 0 && Number(access_rights.projects_basedata_for_own) === 0 && Number(access_rights.projects_capacity_for_other) === 0 &&
                Number(access_rights.projects_capacity_for_own) === 0 && Number(access_rights.projects_consultants_for_other) === 0 &&
                Number(access_rights.projects_consultants_for_own) === 0 && Number(access_rights.projects_fee_for_other) === 0 &&
                Number(access_rights.projects_invoices_for_other) === 0 && Number(access_rights.projects_invoices_for_own) === 0 &&
                Number(access_rights.projects_planning_for_other) === 0 && Number(access_rights.projects_planning_for_own) === 0 &&
                Number(access_rights.projects_activity_for_other) === 0 && Number(access_rights.projects_activity_for_own) === 0)) &&
              !(h.link === "/system_settings" && Number(access_rights.system_settings) === 0) &&
              !(h.link === "/customer" && Number(access_rights.customers) === 0) &&
              !(h.link === "/time_registration" && (Number(access_rights.time_reg_for_own) === 0 && Number(access_rights.time_reg_other_consultants_other) === 0)) &&
              <MenuItem onClick={handleClose} key={`mi-${index}`}>
                <Link key={`ml-${index}`} to={h.link}>{h.title}</Link>
              </MenuItem>
            )
          })
        }
      </Menu>
    </div>
  )
}